<template>
  <div
    :class="{
      'wish-list-item--with-send-button': !isDisabled,
      'wish-list-item--with-send-button--inactive': isDisabled
    }"
  >
    <div v-if="isDisabled" class="wish-list-item--with-send-button__cover-area">
      <div class="wish-list-item--with-send-button__cover" />
      <div class="wish-list-item--with-send-button__cover-tag--thank-you">
        <span class="wish-list-item--with-send-button__cover-tag-title">
          Thank you!
        </span>
        <span class="wish-list-item--with-send-button__cover-tag-caption">
          受け取りたい個数に達しました
        </span>
      </div>
    </div>
    <div class="wish-list-item--with-send-button__information-area">
      <WishListItemSkuBasicInformation
        :image-url="imageUrl"
        :brand-name="brandName"
        :item-name="itemName"
        :item-sku-name="itemSkuName"
        :item-id="itemId"
        :item-sku-id="itemSkuId"
        :has-limit="hasLimit"
        :is-sold-out="isSoldOut"
        :wanted-quantity="wantedQuantity"
        :received-quantity="receivedQuantity"
        class="wish-list-item--with-send-button__sku-basic-information"
        @click-sku-basic-information="clickSkuBasicInformation"
      />
      <div class="wish-list-item--with-send-button__chevron-area">
        <ChevronForward
          class="wish-list-item--with-send-button__chevron-forward"
        />
      </div>
    </div>
    <div
      v-if="!isHiddenSendGiftButton"
      class="wish-list-item--with-send-button__text-link-area"
    >
      <button
        class="wish-list-item--with-send-button__text-link"
        @click="clickSendButton"
      >
        <PlusCircle class="wish-list-item--with-send-button__text-link-icon" />
        このギフトを贈る
      </button>
    </div>
  </div>
</template>
<script>
import WishListItemSkuBasicInformation from '../../atoms/wish_list/WishListItemSkuBasicInformation.vue'
import ChevronForward from '../../atoms/svg_icons/ChevronForward.vue'
import PlusCircle from '../../atoms/svg_icons/PlusCircle.vue'

export default {
  components: {
    WishListItemSkuBasicInformation,
    ChevronForward,
    PlusCircle
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: true
    },
    hasLimit: {
      type: Boolean,
      required: false,
      default: false
    },
    isSoldOut: {
      type: Boolean,
      required: false,
      default: false
    },
    wantedQuantity: {
      type: Number,
      required: false,
      default: 0
    },
    receivedQuantity: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    isDisabled() {
      return this.hasLimit && this.receivedQuantity >= this.wantedQuantity
    },
    isHiddenSendGiftButton() {
      return !this.isDisabled && this.isSoldOut
    }
  },
  methods: {
    clickSkuBasicInformation() {
      if (this.isDisabled) {
        return
      }

      this.$emit(
        'click-sku-basic-information-in-with-send-button',
        this.itemId,
        this.itemSkuId
      )
    },
    clickSendButton() {
      if (this.isDisabled) {
        return
      }

      this.$emit('click-send-button', this.itemId, this.itemSkuId)
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-item {
  &--with-send-button {
    max-width: $small-contents-width;
    padding: 16px;
    margin: auto;
    border-top: 1px solid $gray-2;

    &__information-area {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    &__sku-basic-information {
      width: 100%;
      overflow-x: hidden;
    }

    &__chevron-area {
      margin: auto 6px auto 8px;
    }

    &__chevron-forward {
      width: 24px;
      height: 24px;
      fill: $black;
    }

    &__text-link-area {
      margin-top: 10px;
    }

    &__text-link {
      @extend %body;
      @extend %hover-common;
      width: 100%;
      height: 46px;
      border-radius: 8px;
      border: 1px solid $gray-2;
      display: flex;
      justify-content: left;
      align-items: center;
      padding-left: 14px;
      cursor: pointer;
    }

    &__text-link-icon {
      width: 24px;
      height: 24px;
      margin-right: 6px;
      fill: $gray-1;
    }
  }
}

.wish-list-item--with-send-button--inactive {
  @extend .wish-list-item--with-send-button;
  position: relative;

  .wish-list-item {
    &--with-send-button {
      &__cover {
        background: $light_black_cover;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }

      &__cover-tag {
        z-index: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        background-color: $white;
        border-radius: 8px;
        padding: 16px 24px;

        &--thank-you {
          @extend .wish-list-item--with-send-button__cover-tag;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 4px;
          width: 168px;

          span {
            color: $primary;
          }
        }
      }

      &__cover-tag-title {
        @extend %subhead-bold;
      }

      &__cover-tag-caption {
        @extend %caption;
      }

      &__information-area,
      &__text-link-area {
        opacity: 0.3;
        cursor: default;
      }

      &__text-link {
        cursor: default;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
</style>
